import { isIOS } from 'react-device-detect';

export const batch = {
    API_KEY: isIOS ? 'DEV5D2487866370F661EB326572445' : 'DEV5D1F44C1C394B0CA3C46B826495',
    REST_API_KEY: '307989d39402856eb533a242039d8d4e'
}
export const BATCH_CUSTOM_DATA_API_URL = `https://api.batch.com/1.0/${batch.API_KEY}/data/users`;
export const LOGO_TEAM_URL = process.env.REACT_APP_LOGO_TEAM_URL;
export const API_HOST = process.env.REACT_APP_API_HOST;
export const API_FFF_HOST = process.env.REACT_APP_DOFA;
export const SSO_HOST = process.env.REACT_APP_SSO;
